import React from "react";
import { Box, IconButton } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// Up/down buttons for the Lots text input: the browser only draws its spinner on type="number".
const STEP_BUTTONS_CLASS = "lots-step-buttons";

// Spread into the Lots TextField's sx: like the native spinner, the buttons show on hover or focus.
export const lotsStepButtonsSx = {
  [`& .${STEP_BUTTONS_CLASS}`]: { visibility: "hidden" },
  [`& .MuiInputBase-root:hover .${STEP_BUTTONS_CLASS}, & .Mui-focused .${STEP_BUTTONS_CLASS}`]: {
    visibility: "visible",
  },
};

const LotsStepButtons = ({ onStep, disabled = false }) => {
  const renderButton = (direction, label, Icon) => (
    <IconButton
      size="small"
      tabIndex={-1}
      aria-label={label}
      disabled={disabled}
      onMouseDown={(e) => e.preventDefault()} // keep focus in the input
      onClick={() => onStep(direction)}
      sx={{ p: 0, width: 18, height: 12, borderRadius: 0.5, cursor: "default" }} // arrow cursor, like the native spinner
    >
      <Icon sx={{ fontSize: 18 }} />
    </IconButton>
  );

  return (
    <Box className={STEP_BUTTONS_CLASS} sx={{ display: "flex", flexDirection: "column" }}>
      {renderButton(1, "Increase lots", ArrowDropUpIcon)}
      {renderButton(-1, "Decrease lots", ArrowDropDownIcon)}
    </Box>
  );
};

export default LotsStepButtons;
